module.exports = "<p>\n  create-patient works!\n</p>\n"